export const DEFAULT_AUTHENTICATED_ROUTE = '/workspace'
